import PropTypes from 'prop-types';
import { useMutation, useApolloClient } from '@apollo/client';
import MeasurementGroupDeleteMutation from './MeasurementGroupDeleteMutation';
import MeasurementFetchByDateQuery from '../MeasurementFetchByDate/MeasurementFetchByDateQuery';
import DietSettingsMeasurementsComponentQuery from '../../DietSettingsMeasurementsComponentQuery';
import { useParams } from 'react-router-dom';
import { formatIsoDate } from '../../../../Helpers/dateFormatter';

const MeasurementDeleteByDateConnectorApollo = ({ children }) => {
  const client = useApolloClient();
  const params = useParams();

  const [deleteMeasurements, { loading }] = useMutation(MeasurementGroupDeleteMutation, {
    refetchQueries: [
      {
        query: MeasurementFetchByDateQuery,
        variables: {
          date: params.date ? params.date : formatIsoDate(new Date()),
        },
      },
      {
        query: DietSettingsMeasurementsComponentQuery,
      },
    ],
    awaitRefetchQueries: true,
  });

  const createDeleteMeasurements = async () => {
    const response = await deleteMeasurements({
      variables: {
        request: {
          date: params.date ? params.date : formatIsoDate(new Date()),
        },
      },
    });

    client.cache.evict({
      id: 'UserMeasurement:{}',
    });

    client.cache.gc();

    return response;
  };

  return children({
    deleteMeasurements: createDeleteMeasurements,
    deleting: loading,
  });
};

MeasurementDeleteByDateConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default MeasurementDeleteByDateConnectorApollo;
